<template>
    <BOverlay :show="is_load" rounded="sm">
        <div class="app_vue_list" >
            
            <!-- filter -->
            <div class="filter_block mb-3">
                <protocol_filter
                    v-model:filter="filter"
                    @search_called="handleSearch"
                    @clean_filter="handleCleanFilters"></protocol_filter>
            </div>
            
            <BTable  :thead-class="head_class" :tbody-tr-class="rowClass" hover responsive :items="rows" :fields="table_fields">
                <!-- HEAD FIELDS -->
                <template v-slot:head(id)="data">
                    <grid :list_ordering="'id'" field_name="ID" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                </template>
                
                <template v-slot:head(author_id)="data">
                    <grid :list_ordering="'author_id'" field_name="Створив" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                </template>
                
                <template v-slot:head(date_create)="data">
                    <grid :list_ordering="'date_create'" field_name="Дата" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                </template>
                
                <template v-slot:head(tender)="data">
                    <grid :list_ordering="'tender_id'" field_name="Тендер" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                </template>
                
                <template v-slot:head(status)="data">
                    <grid :list_ordering="'status'" field_name="Статус" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                </template>
                
                <template  v-slot:head(remove_class)="data" title="Видалити">
                    <div class='icon-stack'>
                        <i class="far fa-trash-alt icon-stack-1x opacity-100"></i>
                    </div>
                </template>
                
                <template  v-slot:head(edit_class)="data" title="Редагувати">
                    <div class='icon-stack'>
                        <i class="far fa-edit icon-stack-1x opacity-100"></i>
                    </div>
                </template>
                
                
                <!-- ROW FIELDS -->
                
                <template v-slot:cell(id)="data">
                    <BTooltip>
                        <template #target>
                            <a  :href="'/protokoly/show/' + data.item.id">
                                {{data.item.id}}
                            </a>
                        </template>
                        Переглянути протокол
                    </BTooltip>
                </template>
                
                <template v-slot:cell(author_id)="data">
                    {{data.item?.author?.name}}
                </template>
                
                <template v-slot:cell(tender)="data">
                    <BTooltip>
                        <template #target>
                            <a  :href="'/tender/show/' + data.item.tender_item_id">
                                {{data.item.tender_name}}
                            </a>
                        </template>
                        Переглянути Тендер
                    </BTooltip>
                </template>
                
                <template v-slot:cell(date_create)="data">
                    {{fmtDate(data.item.date_create)}}
                </template>
                
                
                <template  v-slot:cell(status)="data">
                    <div v-if="data.item.status == 'new'">
                        Чернетка
                    </div>
                    <div v-else-if="data.item.status == 'verificated'">
                        На затвердженні
                    </div>
                    
                    <div v-else>
                        {{data.item.status}}
                    </div>
                </template>
                
                <template  v-slot:cell(remove_class)="data">
                    <BTooltip>
                        <template #target>
                            <div class='icon-stack rem_doc' v-on:click="remove_doc(data.item)" title="Видалити">
                                <i class="base base-1 icon-stack-3x opacity-100 color-danger-600"></i>
                                <i class="far fa-trash-alt icon-stack-1x opacity-100 color-white"></i>
                            </div>
                        </template>
                        Видалити
                    </BTooltip>
                
                </template>
                
                <template  v-slot:cell(edit_class)="data">
                    <BTooltip>
                        <template #target>
                            <a  :href="'/protokoly/edit/' + data.item.id">
                                <div class='icon-stack rem_doc' title="Редагувати">
                                    <i class="base base-1 icon-stack-3x opacity-100 color-info-600"></i>
                                    <i class="far fa-edit icon-stack-1x opacity-100 color-white"></i>
                                </div>
                            </a>
                        </template>
                        Редагувати
                    </BTooltip>
                </template>
                
                
            </BTable>
        </div>
        
        <div class="pt-4" v-if="rows.length > 0">
            <pagination
                key="down"
                :total="pagination.total"
                :limit="pagination.limit"
                :current="pagination.pagesCurrent"
                @page-change="handlePageChange">
            </pagination>
        </div>
    
    </BOverlay>
</template>

<script>

import {
    BButton,
    BTable,
    BOverlay,
    BTooltip,
} from 'bootstrap-vue-next';

import grid from "../../../shared/list/grid/grid.vue";
import pagination from "../../../shared/list/pagination/pagination.vue";
import List_filter from "../../../shared/list/filter/list_filter.vue";
import protocol_filter from "./protocol_filter.vue";
import Users_filter from "../../users/list/filter/users_filter.vue";


export default {
    name: "protocol_table",
    
    components : {
        Users_filter,
        List_filter,
        BTable,
        BOverlay,
        BButton,
        BTooltip,
        grid,
        pagination,
        protocol_filter
    },
    
    
    data() {
        return {
            rows: [],
            is_load: true,
            
            list: {
                ordering: "id",
                direction: "DESC",
                start: 0,
                limit: 30
            },
            
            pagination: {
                total: 0,
                limit: 30,
                pagesCurrent: 1
            },
            
            filter: {
                search: "",
                status : "",
            },
            
            fields: [
                { key : 'id',label: 't.id ',class:''},
                { key : 'author_id',label: 'c.name ',class:''},
                { key : 'date_create',label: 't.date_create ',class:''},
                { key : 'tender',label: 't.tender_item_id ',class:''},
                { key : 'status',label: 't.status ',class:''},
                {key : 'remove_class',label: ' ',class:' text-center fs-xxl cursor-pointer'},
                {key : 'edit_class',label: ' ',class:' text-center fs-xxl cursor-pointer'},
            ],
        }
    },
    
    mounted() {
        this.load_items();
    },
    
    created() {
    
    },
    
    
    methods: {
        
        handleOrdering({ordering, direction}) {
            this.list.ordering = ordering;
            this.list.direction = direction;
            this.load_items();
        },
        
        handlePageChange({page, start}) {
            this.list.start = start;
            this.load_items();
        },
        
        handleSearch(search_str) {
            this.filter.search = search_str;
            this.list.start = 0;
            this.load_items();
        },
        
        handleCleanFilters() {
            
            this.filter = {
                search: "",
            };
            
            this.list = {
                ordering: "id",
                direction: "DESC",
                start: 0,
                limit: 30
            };
            
            this.list.start = 0;
            this.load_items();
        },
        
        async load_items() {
            this.is_load = true;
            this.rows = [];
            
            await api.post('/tenders/sales/tenders/protocols',{
                filter  : this.filter,
                list    : this.list
            }).then(({data}) => {
                this.is_load = false;
                if(data.status === "operation_success") {
                    this.rows = data.data;
                    
                    if (data.message?.pagination) {
                        this.pagination = data.message.pagination;
                    }
                }
            }).catch(e => {
                this.is_load = false;
                this.rows = [];
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
        
        rowClass(item) {
            if (!item) return;
            return 'app_' + item.status;
        },
        
        
        remove_doc() {
        
        },
    },
    
    computed : {
        
        head_class() {
        },
        
        table_fields() {
            return this.fields;
        }
    }
}
</script>


<style scoped>

</style>